import React, { useState, useEffect, useContext } from 'react';
import { GlobalStateContext } from './GlobalState';
import parse from 'html-react-parser';
import LinkModal from './LinkModal';
import PlaylistsTableModal from './PlaylistsTableModal';
import PlaylistTableModal from './PlaylistTableModal';
import PlaylistsTable from './PlaylistsTable';
import FeelLuckyModal from './FeelLuckyModal';
import SqueezeMain from './SqueezeMain';
import Card from 'react-bootstrap/Card';
import PlaylistsDropdown from './PlaylistsDropdown';
import PlaylistsCarousel from './PlaylistsCarousel';
import FeelLuckyCarousel from './FeelLuckyCarousel';
import SearchInline from './SearchInline';
import BuilderTextList from './BuilderTextList';
import ChatBox from './ChatBox';

const Builder = () => {
  const [parsedHtml, setParsedHtml] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [chatOpen, setChatOpen] = useState(true);
  const { globalList, addToList, addListToGlobalList, clearPlaylistCache, isLoggedInSpotify } = useContext(GlobalStateContext);

  useEffect(() => {
    /*
    fetch('/_homerun')
      .then(response => response.text())
      .then(data => setParsedHtml(parse(data)))
      .catch(error => console.error(error));
      */
  }, []);
  
  useEffect(() => {
    // Do something when globalStateValue changes
    console.log('Global state value changed:', globalList);
  }, [globalList]);

  return (
    <div className="container">
      <h1 className="cover-heading"><strong className="step-number">1</strong>  Load some songs</h1>
      <Card className="theme-card">
      <Card.Body>
      Pick songs from your own playlist or from pre-built playlists or .. use "Feel Lucky" to let the website choose songs for you based on your listening history.

        <Card.Text>
        <br/>
        {isLoggedInSpotify && (
          <>
            <h1>Feel Lucky</h1>
            <p>Suggestions based on your listening history</p>  
            <FeelLuckyCarousel />
            <br/>
          </>
        )}

        <h1>Search Songs</h1>
        <p>Find runnable songs by name or artist</p>
        <div style={{ maxWidth: '250px', margin: '0 auto' }}>
          <div className="input-group mb-3">
            <span className="input-group-text">
              <i className="bi bi-search"></i>
            </span>
            <input 
              type="text" 
              className="form-control" 
              placeholder="Search songs"
              aria-label="Search songs"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
           <SearchInline inputText={searchText} />
          </div>
        </div>
        
        <h1>Chat Assistant
          <a href="/chat" style={{ fontSize: '0.5em', marginLeft: '10px' }}>
            Open in full page
          </a>
        </h1>
        <p>Ask for music recommendations and playlist building help</p>
        <ChatBox isOpen={chatOpen} onToggle={() => setChatOpen(!chatOpen)} />
        
        <BuilderTextList />
        <br/>
        {isLoggedInSpotify && (
          <>
            <h1>Your Playlists 
              <i 
                className="bi bi-arrow-clockwise" 
                style={{ 
                  fontSize: '0.5em', 
                  marginLeft: '10px',
                  cursor: 'pointer',
                  verticalAlign: 'middle'
                }}
                onClick={() => {
                  clearPlaylistCache();
                  window.location.reload();
                }}
                title="Refresh playlists"
              ></i>
            </h1>
            <p>Pick from your playlists </p>
            <PlaylistsCarousel servicename='/playlistsx' />
          </>
        )}
        
          <h1>Predefined Playlists</h1>
          <p>Need a starting point? Pick songs from these playlists.</p>

          <div className="section-category">
            <h2>Hits 2024</h2>
            <p>End of the year streaming music charts from various sources</p>
            <PlaylistsCarousel servicename='/fixed-playlists-x' p="best2024" />
          </div>

          <div className="section-category">
            <h2>Niche Ideas</h2>
            <p>Curator selected playlists</p>
            <PlaylistsCarousel servicename='/fixed-playlists-x' p="fixed" />
          </div>

          <div className="section-category">
            <h2>World Languages</h2>
            <p>Explore music from around the world</p>
            <PlaylistsCarousel servicename='/fixed-playlists-x' p="foreignlanguages" />
          </div>

          <div className="section-category">
            <h2>Classics</h2>
            <p>Timeless favorites that never get old</p>
            <PlaylistsCarousel servicename='/fixed-playlists-x' p="classics" />
          </div>

          <div className="section-category">
            <h2>Genres</h2>
            <p>Browse music by your favorite style</p>
            <PlaylistsCarousel servicename='/fixed-playlists-x' p="genres" />
          </div>

          <div className="section-category">
            <h2>Cantautori</h2>
            <p>Find Runnable Songs, Also Among Thoughtful Artists</p>
            <PlaylistsCarousel servicename='/fixed-playlists-x' p="cantautori" />
          </div>        
      <br/>
        </Card.Text>
</Card.Body>
</Card>
    <br/>
    </div>
  );
};

export default Builder;
